// Synthesized sound — no audio assets, so nothing to host and nothing to preload.
// Browsers keep an AudioContext suspended until a real gesture, so every entry point resumes it.
let ctx = null;
let muted = localStorage.getItem("ou.muted") === "1";

function ac() {
  ctx ??= new (window.AudioContext ?? window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}
export const isMuted = () => muted;
export function setMuted(v) { muted = v; localStorage.setItem("ou.muted", v ? "1" : "0"); if (!v) ac(); }

/** One enveloped oscillator. `to` sweeps the pitch; `at` offsets from now. */
function tone({ from, to = from, dur = 0.16, type = "triangle", gain = 0.16, at = 0 }) {
  const c = ac(), t = c.currentTime + at;
  const o = c.createOscillator(), g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(from, t);
  if (to !== from) o.frequency.exponentialRampToValueAtTime(to, t + dur);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(c.destination);
  o.start(t); o.stop(t + dur + 0.02);
}

/** Filtered noise — the papery part of a card moving. */
function noise({ dur = 0.11, freq = 1900, q = 0.8, gain = 0.1, at = 0 }) {
  const c = ac(), t = c.currentTime + at;
  const n = Math.floor(c.sampleRate * dur);
  const buf = c.createBuffer(1, n, c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / n); // decaying white noise
  const src = c.createBufferSource(); src.buffer = buf;
  const bp = c.createBiquadFilter(); bp.type = "bandpass"; bp.frequency.value = freq; bp.Q.value = q;
  const g = c.createGain(); g.gain.value = gain;
  src.connect(bp).connect(g).connect(c.destination);
  src.start(t);
}

const SOUNDS = {
  deal:  () => noise({ dur: 0.10, freq: 1500, gain: 0.09 }),
  flip:  () => { noise({ dur: 0.13, freq: 2400, gain: 0.11 }); tone({ from: 320, to: 520, dur: 0.09, gain: 0.05 }); },
  climb: () => { tone({ from: 620, dur: 0.10, gain: 0.13 }); tone({ from: 930, dur: 0.14, gain: 0.11, at: 0.09 }); },
  bust:  () => { tone({ from: 300, to: 120, dur: 0.34, type: "sawtooth", gain: 0.12 }); },
  // A push is neither a win nor a loss: two flat, equal tones — deliberately "level".
  push:  () => { tone({ from: 520, dur: 0.13, gain: 0.12 }); tone({ from: 520, dur: 0.19, gain: 0.12, at: 0.17 }); },
  bank:  () => { tone({ from: 880, dur: 0.12, gain: 0.13 }); tone({ from: 1320, dur: 0.26, gain: 0.11, at: 0.10 }); },
  top:   () => [660, 880, 1100, 1560].forEach((f, i) =>
           tone({ from: f, dur: i === 3 ? 0.42 : 0.13, gain: 0.12, at: i * 0.10 })),
};

export function play(name) {
  if (muted) return;
  try { SOUNDS[name]?.(); } catch { /* audio is a nicety; never let it break a round */ }
}
